/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_ev_spots__many = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Plätze`
};

const en_ev_spots__many = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} spots`
};

const es_ev_spots__many = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} plazas`
};

const fr_ev_spots__many = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} places`
};

const it_ev_spots__many = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} posti`
};

const nl_ev_spots__many = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} plaatsen`
};

const pt_ev_spots__many = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} lugares`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ev_spots__many = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ev_spots__many(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("ev_spots__many", locale)
	if (locale === "de") return de_ev_spots__many(inputs)
	if (locale === "en") return en_ev_spots__many(inputs)
	if (locale === "es") return es_ev_spots__many(inputs)
	if (locale === "fr") return fr_ev_spots__many(inputs)
	if (locale === "it") return it_ev_spots__many(inputs)
	if (locale === "nl") return nl_ev_spots__many(inputs)
	return pt_ev_spots__many(inputs)
};